
import {
getWorkOrder,
finishWorkOrder,
getTerminalDetail
} from '@/common/js/api.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'


export default {
components: {
XHeader,
Box,
XButton,
Group,
CellBox,
Cell,
Scroller,
Icon,
VChart,
VTooltip,
VLine,
Flexbox,
FlexboxItem,
VScale
},
methods: {
getWorkOrder(orderId) {
let self = this
getWorkOrder({ data: { orderId: orderId } }).then(function(data) {
self.entity = data.Content
if (self.entity.category === 'INSTALL_TERMINAL') {
self.view.fieldText = '现在去安装'
} else if (self.entity.category === 'PICK_RECYCLE') {
self.view.fieldText = '现在去收衣'
} else if (self.entity.category === 'TERMINAL_TROUBLE') {
self.getTerminalDetail()
} else if (self.entity.category === 'PARTNER_PICK_UP') {

self.view.fieldText = '导航'
}
})
},
doWork() {
let self = this
if (self.entity.category === 'INSTALL_TERMINAL') {
self.$router.push({
path: '/support/install',
query: { orderId: self.entity.orderId, sid: self.entity.objectId }
})
} else if (self.entity.category === 'PICK_RECYCLE') {
self.$router.push({
path: '/support/terminalControl',
query: {
sid: self.entity.objectId,
orderId: self.entity.orderId,
category: self.entity.category
}
})
} else if (self.entity.category === 'TERMINAL_TROUBLE') {

self.$router.push({
path: '/support/terminalControl',
query: {
sid: self.entity.objectId,
orderId: self.entity.orderId,
category: self.entity.category
}
})
} else if (self.entity.category === 'PARTNER_PICK_UP') {

self.$router.push({
path: '/support/partnerRoute',
query: {
partnerId: self.entity.objectId,
orderId: self.entity.orderId,
category: self.entity.category
}
})
}
},
finishWorkOrder(confirmNote) {
let self = this
this.$vux.confirm.show({
title: '提醒您',
content: confirmNote,
onCancel() {},
onConfirm() {
self.times = 0
finishWorkOrder({ data: { orderId: self.entity.orderId } }).then(
function(data) {
self.$vux.toast.text('操作成功')
self.entity.status = 2
}
)
}
})
},
getTerminalDetail() {
let self = this
getTerminalDetail({ data: { terminalId: self.entity.objectId } }).then(
function(data) {
self.currentTerminal = data.Content
self.view.fieldText = '查看'
}
)
},
getWeek() {
var d = new Date(this.entity.createTime).getDay()
if (d == 1) {
return '星期一'
} else if (d == 2) {
return '星期二'
} else if (d == 3) {
return '星期三'
} else if (d == 4) {
return '星期四'
} else if (d == 5) {
return '星期五'
} else if (d == 6) {
return '星期六'
} else if (d == 0) {
return '星期日'
}
}
},
data() {
return {
entity: {},
view: {
fieldText: ''
}
}
},
created() {
let orderId = this.$route.query.orderId
this.getWorkOrder(orderId)
}
}



// WEBPACK FOOTER //
// ./src/components/support/WorkOrderDetail.vue